import { render, staticRenderFns } from "./StudentAiTutorView.vue?vue&type=template&id=0143329e&scoped=true&"
import script from "./StudentAiTutorView.vue?vue&type=script&lang=js&"
export * from "./StudentAiTutorView.vue?vue&type=script&lang=js&"
import style0 from "./StudentAiTutorView.vue?vue&type=style&index=0&id=0143329e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143329e",
  null
  
)

export default component.exports